import { CapoPlugin } from "/codebuild/output/src423944966/src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];